import { render, staticRenderFns } from "./maximize.vue?vue&type=template&id=a71ebea6"
import script from "./maximize.vue?vue&type=script&lang=js"
export * from "./maximize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports